import { Message } from '../../../../../chat-common/src/lib/models/message';
import { ChatOption } from '../../../../../chat-common/src/lib/models/chat.option';
import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions, Timestamp } from '@firebase/firestore';

export class ChatMessage extends Message {
  override chatVersion = '2.0'
  answer: { card: string, cta: string, options: Array<ChatOption> }
  constructor(message: string) {
    super();
    this.message = message;
    this.source = 'user';
    this.date = new Date();
  }

  static mockLogResponse(data: string): ChatMessage {
    let response = `I’ve logged ${data} for you. Would you like me to show how it connects to your health?`;
    let message = new ChatMessage(response);
    message.source = 'assistant';
    message.answer = {
      card: 'C3',
      cta: 'SINGLE',
      options: [new ChatOption('uknown', 'Yes'), new ChatOption('pass', 'No')]
    }
    return message;
  }

   static mockDownloadReportResponse(): ChatMessage {
    let response = `Your report is being requested. Check your e-mail in a few minutes.`;
    let message = new ChatMessage(response);
    message.source = 'assistant';
    message.answer = {
      card: 'C1',
      cta: 'NONE',
      options: []
    }
    return message;
  }

  static mockPassResponse(): ChatMessage {
    let response = `Alright, we’ll leave it there for now.`;
    let message = new ChatMessage(response);
    message.source = 'assistant';
    message.answer = {
      card: 'C1',
      cta: 'NONE',
      options: []
    }
    return message;
  }

  static toFirestoreMessage(msg: ChatMessage) {
    return {
      chatVersion: msg.chatVersion,
      message: msg.message,
      source: msg.source,
      date: msg.date,
      answer: msg.answer
        ? {
            card: msg.answer.card,
            cta: msg.answer.cta,
            options: (msg.answer.options ?? []).map(o => ({
              action: o.action,
              display: o.display,
            })),
          }
        : null,
    };
  }
}
